<template>
    <card-tab-label v-slot="{ bindings }" name="tasks">
        <text-decorator
            :color="bindings?.isActive ? Color.brandPurple : Color.gray500"
            :size="FontSize.sm"
            bold
        >
            Taken
        </text-decorator>
        <chip-informative small :color="bindings?.isActive ? Color.brandPurple : Color.gray500">
            {{ count }}
        </chip-informative>
    </card-tab-label>
</template>

<script lang="ts" setup>
    import { CardTabLabel, ChipInformative, Color, FontSize } from '@keyvue/one-ui';
    import { computed } from 'vue';
    import type { TaskOverview } from '@composables/useTaskOverview';

    interface Props {
        taskOverview: TaskOverview;
    }

    const props = defineProps<Props>();

    // All tasks, as before: the active ones plus the completed ones (counted, not loaded).
    const count = computed(() => props.taskOverview.active.count.value + props.taskOverview.completedCount.value);
</script>
